import { render, staticRenderFns } from "./sales-profile.vue?vue&type=template&id=f12dab3c&scoped=true"
import script from "./sales-profile.vue?vue&type=script&lang=js"
export * from "./sales-profile.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f12dab3c",
  null
  
)

export default component.exports